export default {
  title: "Team",
  edit: "Edit team",
  label_team: "Team",
  label_provider: "Provider",
  placeholder: "No team assigned",
};
